import { axiosBaseQuery, createAxiosInstance } from '@client';
import { getEnvironmentVariables } from '@common';
import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { HlAiBankAccountDetails, HlAiDaHelperResponse } from '@state';
import { S3ObjectResponse } from '@module';

const { HL_AI_API_URL } = getEnvironmentVariables();

const axiosHarborlabAiInstance = createAxiosInstance({
  baseURLParam: `${HL_AI_API_URL}`
});

export type LocateExpensesInAttachmentTrigger = ReturnType<
  typeof useLocateExpensesInAttachmentMutation
>[0];

export type PollForLocatedExpensesInAttachmentTrigger = ReturnType<
  typeof usePollForLocatedExpensesInAttachmentMutation
>[0];

export const harborlabAiApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: '',
    customAxiosInstance: axiosHarborlabAiInstance
  }),
  reducerPath: 'harborlab-ai',
  endpoints: (build) => ({
    extractBankAccountDetails: build.mutation<
      HlAiBankAccountDetails,
      S3ObjectResponse
    >({
      query: (payload) => ({
        url: '/bank-account-details',
        method: 'POST',
        data: payload
      })
    }),
    locateExpensesInAttachment: build.mutation<
      void,
      { s3ObjectDetails: S3ObjectResponse; expenseNames: string[] }
    >({
      query: ({ s3ObjectDetails, expenseNames }) => ({
        url: '/da-helper',
        method: 'POST',
        data: {
          s3Bucket: s3ObjectDetails.s3Bucket,
          s3FileKey: s3ObjectDetails.s3FileKey,
          daExpenses: expenseNames
        }
      })
    }),
    pollForLocatedExpensesInAttachment: build.mutation<
      HlAiDaHelperResponse,
      { s3ObjectDetails: S3ObjectResponse }
    >({
      query: ({ s3ObjectDetails }) => ({
        url: '/da-helper-results-poller',
        method: 'POST',
        data: {
          s3Bucket: s3ObjectDetails.s3Bucket,
          s3FileKey: s3ObjectDetails.s3FileKey
        }
      })
    })
  })
});

export type StateWithHarborlabAiApi = {
  [harborlabAiApi.reducerPath]: ReturnType<typeof harborlabAiApi.reducer>;
};

export const {
  useExtractBankAccountDetailsMutation,
  useLocateExpensesInAttachmentMutation,
  usePollForLocatedExpensesInAttachmentMutation
} = harborlabAiApi;
